import styled from 'styled-components'

import { Button, Table, TableComponents } from '@sketch/components'

export const InputWrapper = styled.div`
  display: flex;
  margin: 24px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
  padding-top: 24px;
`

export const AddToListButton = styled(Button)`
  margin-top: auto;
  margin-left: 16px;
`

export const MembersTable = styled(Table)`
  max-height: 300px;
  width: 100%;
` as typeof Table

export const MinimalTableCell = styled(TableComponents.TableCell)`
  width: 0;
`
